import styled from 'styled-components';

import { IconWrapper } from '@dreryk/react-components';

export const StyledContinuouslyUsedMedicineIconWrapper = styled(IconWrapper)`
   vertical-align: middle;
   display: inline-flex;
`;
